import { FC } from 'react';
import { GatsbyContext } from './GatsbyContext';
import { useMutation } from '@apollo/client';
import { ADD_INQUIRY_MUTATION } from '../common.queries';
import { InquiryForm } from './GatsbyInterface';

export interface GatsbyProviderProps {
  children: React.ReactNode;
}

export const GatsbyProvider: FC<GatsbyProviderProps> = ({ children }) => {
  const [subscibe] = useMutation(ADD_INQUIRY_MUTATION);

  const addInquiry = (input: InquiryForm) => {
    subscibe({
      variables: { input },
    });
  };

  return (
    <GatsbyContext.Provider
      value={{
        addInquiry,
      }}
    >
      {children}
    </GatsbyContext.Provider>
  );
};
